import faceSaraChen from "../assets/face-sara-chen.png";
import logoSleepDeepDive from "../assets/logo-sleep-deep-dive.png";

// ─── Example skill data ───────────────────────────────────────────────────────
const SLEEP = {
  name: "Sleep Deep Dive",
  creator: "Dr. Sara Chen",
  category: "Recovery",
  primary: "#4A90D9",
  accent: "#E8A23C",
  description:
    "Analyse 30 nights of sleep data and surface recovery patterns, deep sleep cycles, and energy readiness.",
  users: "2,400",
  rating: "4.8",
  insight:
    "Your deep sleep dropped 18% this week — linked to later bedtimes on Tuesday and Thursday.",
  metrics: [
    { label: "Sleep score", value: "84 / 100", color: "primary" },
    { label: "Deep sleep", value: "1h 42m", color: "primary" },
    { label: "Recovery energy", value: "High", color: "accent" },
    { label: "Bedtime consistency", value: "−23 min", color: "accent" },
  ],
};

const OTHER_SKILLS = [
  {
    name: "Metabolic Load",
    creator: "NutriLab",
    category: "Nutrition",
    primary: "#E8853A",
    insight: "Glucose stable. Meal timing shifted earlier.",
  },
  {
    name: "Cardio Baseline",
    creator: "Heart Institute",
    category: "Cardiovascular",
    primary: "#D9536A",
    insight: "Resting HR down 4 bpm over 30 days.",
  },
];

// ─── Surface 1: Home screen widget ───────────────────────────────────────────

function HomeWidgetSurface() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 0,
        borderRadius: 20,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.07)",
        background: "#F5F3EF",
      }}
    >
      {/* Platform chrome top */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 14px 8px",
          background: "rgba(255,255,255,0.8)",
          borderBottom: "1px solid rgba(0,0,0,0.05)",
        }}
      >
        <span
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 15,
            fontWeight: 700,
            color: "#1F2421",
          }}
        >
          Kin
        </span>
        <div style={{ display: "flex", gap: 12 }}>
          {["Home", "Skills", "Vault"].map((t, i) => (
            <span
              key={t}
              style={{
                fontSize: 10,
                fontWeight: i === 0 ? 700 : 500,
                color: i === 0 ? "#2FB56A" : "#877e76",
              }}
            >
              {t}
            </span>
          ))}
        </div>
      </div>

      <div style={{ padding: "14px 12px", display: "flex", flexDirection: "column", gap: 8 }}>
        {/* Greeting */}
        <div>
          <div style={{ fontSize: 11, color: "#877e76" }}>Good morning</div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#1F2421",
              fontFamily: "'Cormorant Garamond', serif",
            }}
          >
            Today's highlights
          </div>
        </div>

        {/* Kin curation label */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 2px",
          }}
        >
          <span
            style={{
              fontSize: 8,
              fontWeight: 700,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: "#b0a89f",
            }}
          >
            Most relevant today
          </span>
          <span style={{ fontSize: 8, color: "#b0a89f" }}>3 of 6 skills</span>
        </div>

        {/* Featured skill widget */}
        <div
          style={{
            borderRadius: 14,
            background: `${SLEEP.primary}12`,
            border: `1px solid ${SLEEP.primary}22`,
            overflow: "hidden",
          }}
        >
          <div style={{ display: "flex", height: 4 }}>
            <div style={{ flex: 3, background: SLEEP.primary }} />
            <div style={{ flex: 1, background: SLEEP.accent }} />
            <div style={{ flex: 4, background: `${SLEEP.primary}18` }} />
          </div>
          <div style={{ padding: "10px 12px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
              <img
                src={logoSleepDeepDive}
                alt=""
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 7,
                  background: "#fff",
                  padding: 3,
                  border: `1px solid ${SLEEP.primary}18`,
                  objectFit: "contain",
                  flexShrink: 0,
                }}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#1F2421",
                    fontFamily: "'Cormorant Garamond', serif",
                  }}
                >
                  {SLEEP.name}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 1 }}>
                  <img
                    src={faceSaraChen}
                    alt=""
                    style={{ width: 12, height: 12, borderRadius: "50%", objectFit: "cover" }}
                  />
                  <span style={{ fontSize: 8, color: SLEEP.primary, fontWeight: 600 }}>
                    {SLEEP.creator}
                  </span>
                </div>
              </div>
              <span
                style={{
                  fontSize: 8,
                  fontWeight: 700,
                  color: SLEEP.primary,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                {SLEEP.category}
              </span>
            </div>
            <div style={{ fontSize: 9, color: "#3a3230", lineHeight: 1.45 }}>{SLEEP.insight}</div>
            <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
              <div
                style={{
                  padding: "4px 10px",
                  borderRadius: 6,
                  background: SLEEP.primary,
                  fontSize: 8,
                  fontWeight: 700,
                  color: "#fff",
                }}
              >
                View
              </div>
              <div
                style={{
                  padding: "4px 10px",
                  borderRadius: 6,
                  background: `${SLEEP.primary}14`,
                  border: `1px solid ${SLEEP.primary}22`,
                  fontSize: 8,
                  fontWeight: 600,
                  color: SLEEP.primary,
                }}
              >
                Run again
              </div>
            </div>
          </div>
        </div>

        {/* Other skill widgets — compact */}
        {OTHER_SKILLS.map((s) => (
          <div
            key={s.name}
            style={{
              borderRadius: 10,
              background: `${s.primary}0d`,
              border: `1px solid ${s.primary}1e`,
              padding: "8px 10px",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <div
              style={{
                width: 24,
                height: 24,
                borderRadius: 6,
                background: `${s.primary}18`,
                border: `1px solid ${s.primary}22`,
                flexShrink: 0,
              }}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: "#1F2421" }}>{s.name}</div>
              <div style={{ fontSize: 8, color: "#6F7D76", marginTop: 1 }}>{s.insight}</div>
            </div>
            <div
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: s.primary,
                flexShrink: 0,
              }}
            />
          </div>
        ))}
      </div>

      {/* Platform tab bar */}
      <div
        style={{
          display: "flex",
          borderTop: "1px solid rgba(0,0,0,0.06)",
          background: "rgba(255,255,255,0.9)",
        }}
      >
        {[
          { label: "Home", active: true },
          { label: "Skills" },
          { label: "Vault" },
          { label: "Profile" },
        ].map((t) => (
          <div
            key={t.label}
            style={{
              flex: 1,
              padding: "8px 0 6px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <div
              style={{
                width: 16,
                height: 3,
                borderRadius: 2,
                background: t.active ? "#2FB56A" : "rgba(0,0,0,0.08)",
              }}
            />
            <span
              style={{
                fontSize: 8,
                fontWeight: t.active ? 700 : 500,
                color: t.active ? "#2FB56A" : "#b0a89f",
              }}
            >
              {t.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Surface 2: Marketplace listing ──────────────────────────────────────────

function MarketplaceSurface() {
  return (
    <div
      style={{
        borderRadius: 20,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.07)",
        background: "#F5F3EF",
      }}
    >
      {/* Palette strip — skill identity */}
      <div style={{ display: "flex", height: 4 }}>
        <div style={{ flex: 3, background: SLEEP.primary }} />
        <div style={{ flex: 1, background: SLEEP.accent }} />
        <div style={{ flex: 4, background: `${SLEEP.primary}18` }} />
      </div>

      {/* Platform chrome */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 14px 8px",
          background: "rgba(255,255,255,0.8)",
          borderBottom: "1px solid rgba(0,0,0,0.05)",
        }}
      >
        <span style={{ fontSize: 10, color: "#877e76" }}>← Skills</span>
        <span
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 13,
            fontWeight: 700,
            color: "#1F2421",
          }}
        >
          Kin
        </span>
        <span style={{ fontSize: 10, color: "#2FB56A", fontWeight: 600 }}>Browse</span>
      </div>

      {/* Skill hero — skill owns this */}
      <div
        style={{
          background: `${SLEEP.primary}16`,
          borderBottom: `1px solid ${SLEEP.primary}20`,
          padding: "18px 16px 14px",
          display: "flex",
          gap: 14,
          alignItems: "flex-start",
        }}
      >
        <img
          src={logoSleepDeepDive}
          alt=""
          style={{
            width: 56,
            height: 56,
            borderRadius: 14,
            background: "#fff",
            padding: 6,
            border: `1px solid ${SLEEP.primary}20`,
            objectFit: "contain",
            flexShrink: 0,
            boxShadow: `0 4px 12px -4px ${SLEEP.primary}30`,
          }}
        />
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: "inline-block",
              padding: "2px 7px",
              borderRadius: 5,
              background: `${SLEEP.primary}18`,
              border: `1px solid ${SLEEP.primary}28`,
              marginBottom: 5,
            }}
          >
            <span
              style={{
                fontSize: 8,
                fontWeight: 700,
                color: SLEEP.primary,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
              }}
            >
              {SLEEP.category}
            </span>
          </div>
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: "#1F2421",
              fontFamily: "'Cormorant Garamond', serif",
              lineHeight: 1.15,
            }}
          >
            {SLEEP.name}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 4 }}>
            <img
              src={faceSaraChen}
              alt=""
              style={{ width: 16, height: 16, borderRadius: "50%", objectFit: "cover" }}
            />
            <span style={{ fontSize: 9, fontWeight: 600, color: SLEEP.primary }}>
              {SLEEP.creator}
            </span>
          </div>
        </div>
      </div>

      <div style={{ padding: "12px 14px", display: "flex", flexDirection: "column", gap: 10 }}>
        {/* Rating + users */}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ display: "flex", gap: 2 }}>
            {[1, 2, 3, 4, 5].map((i) => (
              <svg
                key={i}
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill={i < 5 ? SLEEP.primary : "none"}
                stroke={SLEEP.primary}
                strokeWidth="1"
              >
                <polygon points="5,1 6.2,3.8 9.5,4 7,6.2 7.8,9.5 5,7.8 2.2,9.5 3,6.2 0.5,4 3.8,3.8" />
              </svg>
            ))}
          </div>
          <span style={{ fontSize: 9, fontWeight: 700, color: "#1F2421" }}>{SLEEP.rating}</span>
          <span style={{ fontSize: 9, color: "#877e76" }}>· {SLEEP.users} users</span>
        </div>

        {/* Description */}
        <p style={{ fontSize: 10, color: "#3a3230", lineHeight: 1.55, margin: 0 }}>
          {SLEEP.description}
        </p>

        {/* What it analyses */}
        <div>
          <div
            style={{
              fontSize: 8,
              fontWeight: 700,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: "#877e76",
              marginBottom: 5,
            }}
          >
            Analyses
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {["Sleep stages", "HRV", "Recovery score", "Bedtime rhythm", "Energy readiness"].map(
              (tag) => (
                <span
                  key={tag}
                  style={{
                    padding: "3px 8px",
                    borderRadius: 5,
                    background: `${SLEEP.primary}0d`,
                    border: `1px solid ${SLEEP.primary}1e`,
                    fontSize: 8,
                    fontWeight: 600,
                    color: SLEEP.primary,
                  }}
                >
                  {tag}
                </span>
              ),
            )}
          </div>
        </div>

        {/* CTA — Kin green (platform action) */}
        <div
          style={{
            padding: "9px 0",
            borderRadius: 10,
            background: "#2FB56A",
            fontSize: 11,
            fontWeight: 700,
            color: "#fff",
            textAlign: "center",
            marginTop: 2,
          }}
        >
          Add skill
        </div>
        <div style={{ fontSize: 8, color: "#b0a89f", textAlign: "center", marginTop: -4 }}>
          Free · Requires sleep tracker data
        </div>
      </div>
    </div>
  );
}

// ─── Surface 3: Skill view ────────────────────────────────────────────────────

function SkillViewSurface() {
  return (
    <div
      style={{
        borderRadius: 20,
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.07)",
        background: `${SLEEP.primary}06`,
      }}
    >
      {/* Palette strip — skill identity */}
      <div style={{ display: "flex", height: 4 }}>
        <div style={{ flex: 3, background: SLEEP.primary }} />
        <div style={{ flex: 1, background: SLEEP.accent }} />
        <div style={{ flex: 4, background: `${SLEEP.primary}18` }} />
      </div>

      {/* Minimal platform chrome */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 14px 8px",
          borderBottom: `1px solid ${SLEEP.primary}14`,
        }}
      >
        <span style={{ fontSize: 10, color: "#877e76" }}>← Skills</span>
        <span
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 13,
            fontWeight: 700,
            color: "#1F2421",
          }}
        >
          Kin
        </span>
        <span style={{ fontSize: 10, color: "#877e76" }}>Share</span>
      </div>

      {/* Skill header — full identity */}
      <div
        style={{
          padding: "14px 14px 12px",
          background: `${SLEEP.primary}14`,
          borderBottom: `1px solid ${SLEEP.primary}18`,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img
            src={logoSleepDeepDive}
            alt=""
            style={{
              width: 44,
              height: 44,
              borderRadius: 11,
              background: "#fff",
              padding: 5,
              border: `1px solid ${SLEEP.primary}20`,
              objectFit: "contain",
              flexShrink: 0,
            }}
          />
          <div>
            <div
              style={{
                fontSize: 18,
                fontWeight: 700,
                color: "#1F2421",
                fontFamily: "'Cormorant Garamond', serif",
                lineHeight: 1.1,
              }}
            >
              {SLEEP.name}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 3 }}>
              <img
                src={faceSaraChen}
                alt=""
                style={{ width: 14, height: 14, borderRadius: "50%", objectFit: "cover" }}
              />
              <span style={{ fontSize: 8, fontWeight: 600, color: SLEEP.primary }}>
                {SLEEP.creator}
              </span>
              <span style={{ fontSize: 8, color: "#b0a89f" }}>· 2h ago</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main insight — skill voice */}
      <div
        style={{
          margin: "12px 12px 0",
          padding: "10px 12px",
          borderRadius: 12,
          background: `${SLEEP.primary}0e`,
          border: `1px solid ${SLEEP.primary}1a`,
        }}
      >
        <div
          style={{
            fontSize: 8,
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: SLEEP.primary,
            marginBottom: 4,
          }}
        >
          Key insight
        </div>
        <div style={{ fontSize: 11, color: "#1F2421", lineHeight: 1.5 }}>{SLEEP.insight}</div>
      </div>

      {/* Metrics */}
      <div style={{ padding: "10px 12px", display: "flex", flexDirection: "column", gap: 5 }}>
        {SLEEP.metrics.map((m) => (
          <div
            key={m.label}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "6px 10px",
              borderRadius: 9,
              background: "rgba(255,255,255,0.72)",
              border: `1px solid ${m.color === "primary" ? SLEEP.primary : SLEEP.accent}14`,
            }}
          >
            <span style={{ fontSize: 9, color: "#4F5D56" }}>{m.label}</span>
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: m.color === "primary" ? SLEEP.primary : SLEEP.accent,
              }}
            >
              {m.value}
            </span>
          </div>
        ))}
      </div>

      {/* Actions */}
      <div style={{ padding: "4px 12px 14px", display: "flex", gap: 6 }}>
        <div
          style={{
            flex: 1,
            padding: "8px 0",
            borderRadius: 9,
            background: SLEEP.primary,
            fontSize: 10,
            fontWeight: 700,
            color: "#fff",
            textAlign: "center",
          }}
        >
          Run new analysis
        </div>
        <div
          style={{
            padding: "8px 12px",
            borderRadius: 9,
            background: "rgba(255,255,255,0.7)",
            border: `1px solid ${SLEEP.primary}18`,
            fontSize: 10,
            fontWeight: 600,
            color: "#4F5D56",
          }}
        >
          History
        </div>
      </div>
    </div>
  );
}

// ─── Section ─────────────────────────────────────────────────────────────────

const surfaces = [
  {
    id: "home",
    label: "Home screen widget",
    rule: "One of many. Platform shell, skill signal.",
    detail:
      "On the home screen the platform imposes consistent card dimensions and elevation across all skill widgets. The skill's lead color comes through as a tint and a single accent element — enough to be recognised at a glance. The featured widget is slightly larger, chosen by Kin's curation logic.",
    Demo: HomeWidgetSurface,
  },
  {
    id: "marketplace",
    label: "Marketplace listing",
    rule: "Discovery. The skill makes its case.",
    detail:
      "In the marketplace the skill has more room. Its logo is larger, its description full, its category and creator prominent. The 'Add skill' button stays Kin green — that's a platform action. Everything else belongs to the skill: color, voice, what it promises to analyse.",
    Demo: MarketplaceSurface,
  },
  {
    id: "view",
    label: "Skill view",
    rule: "Full canvas. Platform disappears.",
    detail:
      "Once the user enters a skill, platform chrome collapses to a thin bar — back navigation, the Kin wordmark, a share action. The skill owns the rest: its logo, its color at full saturation, its data presentation, its voice. Primary metrics use the skill's primary color; secondary data uses the accent.",
    Demo: SkillViewSurface,
  },
];

export default function Skill() {
  return (
    <section
      id="skill"
      className="kin-section-glow border-t border-kin-olive/10 px-6 py-14 scroll-mt-16 sm:px-8 sm:py-16 gradient-wash"
    >
      <div className="mx-auto max-w-6xl">
        {/* ── Header ── */}
        <p className="text-sm font-semibold tracking-[0.22em] uppercase text-kin-muted">
          05 — Skill
        </p>
        <div className="mt-6 max-w-3xl">
          <h2 className="font-serif text-4xl font-bold leading-tight text-kin-black sm:text-5xl">
            The skill owns its moment.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-kin-body/90 sm:text-lg">
            A skill surfaces in three distinct contexts — each with a different amount of space and
            a different job to do. The platform controls the shell; the skill controls everything
            inside it.
          </p>
        </div>

        {/* ── Three surfaces ── */}
        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {surfaces.map(({ id, label, rule, detail, Demo }) => (
            <div key={id} className="flex flex-col gap-4">
              {/* Label */}
              <div>
                <p className="text-[10px] font-semibold tracking-[0.18em] uppercase text-kin-muted">
                  {label}
                </p>
                <p className="mt-1 text-sm font-semibold text-kin-black">{rule}</p>
              </div>

              {/* Demo */}
              <Demo />

              {/* Detail */}
              <p className="text-xs leading-relaxed text-kin-body/80">{detail}</p>
            </div>
          ))}
        </div>

        {/* ── Skill anatomy ── */}
        <div className="mt-12 kin-surface rounded-[24px] p-6 sm:p-8">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-kin-muted mb-5">
            Skill anatomy — consistent elements across all three surfaces
          </p>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {[
              {
                element: "Logo mark",
                rule: "Every skill has a mark.",
                detail:
                  "Shown at 28px (widget), 56px (marketplace), 44px (skill view). Always on a white or near-white tile — never directly on a colored surface.",
              },
              {
                element: "Creator identity",
                rule: "Face + name, always together.",
                detail:
                  "Creator portrait (circular crop) paired with name in the skill's primary color. Establishes authorship and accountability across every surface.",
              },
              {
                element: "Primary + accent",
                rule: "Two colors, two data categories.",
                detail:
                  "Primary color for the skill's main signal. Accent for secondary or complementary data. The colors should encode different kinds of meaning, not just different shades.",
              },
              {
                element: "Platform actions",
                rule: "Always Kin green.",
                detail:
                  "'Add skill', 'Run again', 'Share' — any action that touches the platform layer uses Kin green, not the skill's color. The distinction makes the ownership clear.",
              },
            ].map((item) => (
              <div
                key={item.element}
                className="rounded-[18px] border border-kin-white/50 bg-kin-white/60 px-4 py-3 shadow-sm backdrop-blur-md"
              >
                <p className="text-[10px] font-semibold tracking-[0.14em] uppercase text-kin-muted mb-1">
                  {item.element}
                </p>
                <p className="text-xs font-semibold text-kin-black mb-1">{item.rule}</p>
                <p className="text-[10px] leading-relaxed text-kin-body/70">{item.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
